<script>
  import { onMount } from 'svelte';
  import {
    carregaProduto,
    editaProduto,
    listaCategorias,
    listaPromocoes
  } from '../../actions/database.js';
  import { upload } from '../../actions/upload.js';
  import { categorias, promocoes } from '../../store/store.js';

  import Page from "../../containers/Page/Page.svelte";
  import Modal from "../../components/Modal/Modal.svelte";

  export let params = {}

  let produto;
  let files;
  let alert;
  let uploading;
  let error;

  $: listCategorias = $categorias;
  $: listPromocoes = $promocoes;

  onMount(async () => {
    produto = await carregaProduto(params.id);
    await listaCategorias();
    await listaPromocoes();
  });

  const handleUpload = async () => {
    error = null;
    if (files[0].size > 50000000) { // 50MB
      error = 'Tamanho máximo permitido é de 50MB.';
      return;
    }
    uploading = true;
    produto.image = await upload(files[0]);
    uploading = false;
  }

  const handleEdit = async () => {
    alert = "Atualizando...";
    try {
      await editaProduto(produto);
      alert = "Produto atualizado!";
    } catch (error) {
      alert = `Erro ao atualizar o produto: ${error}`;
    }
  }

  const close = () => alert = null;
</script>

{#if alert}
  <Modal
    { alert }
    { close }
  />
{/if}

{#if produto}
  <Page title="Editar Produto { produto.nome }">
    <div class="box">
      <div class="field is-horizontal">
        <div class="content">
          <h3>Dados do produto:</h3>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Nome</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input bind:value={produto.nome} class="input" type="text">
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Categoria</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <select bind:value={produto.categoria}>
                {#each listCategorias as categoria}
                  <option value={categoria.nome}>{categoria.nome}</option>
                {/each}
              </select>
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Promoção</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <select bind:value={produto.promocaoSlug}>
              <option value="">Escolha uma promoção</option>
                {#each listPromocoes as promocao}
                  <option value={promocao.slug}>{promocao.nome}</option>
                {/each}
              </select>
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Ativo</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control is-expanded">
              <div class="select">
                <select bind:value={produto.ativo}>
                  <option value="nao">Não</option>
                  <option value="sim">Sim</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Preço</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input bind:value={produto.preco} class="input" type="text">
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Preço Promocional</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input bind:value={produto.precoPromocao} class="input" type="text">
            </p>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Imagem</label>
        </div>
        <div class="field-body">
          <div class="field">
            <p class="control is-expanded">
              <input bind:files on:change={handleUpload} class="input" type="file" accept="image/*">
            </p>
            <br>
            {#if error}
               <div class="error notification is-danger is-small">
                { error }
               </div>
            {/if}
            {#if uploading}
              <p class="control is-expanded">
                Fazendo upload 
                <progress class="progress is-small is-primary"></progress>
              </p>
            {/if}
            {#if produto.image}
              <div>
                <img width="300" src={produto.image} alt=""/>
              </div>
              <button on:click={() => produto.image = null}>
                Remover imagem
              </button>
            {/if}
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Descrição Mente Aberta</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <textarea bind:value={produto.descricao} class="textarea"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Descrição Técnica</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <textarea bind:value={produto.descricaoTecnica} class="textarea"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Conteúdo da Embalagem</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <textarea bind:value={produto.embalagem} class="textarea"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Características</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <textarea bind:value={produto.caracteristicas} class="textarea"></textarea>
            </div>
          </div>
        </div>
      </div>
    <div class="control has-text-right">
      <button
        on:click={handleEdit}
        class="button is-primary"
      >
        Atualizar dados de produto
      </button>
    </div>
    </div>

  </Page>
{/if}

<style>
  .error.notification {
    padding: 10px;
  }
</style>